<template>
  <div class="main-container page-container">
    <div class="top-box">
      <div class="templateName">
        <span class="name">{{ tableItem.name }}</span>
        <div class="action-btn">
          <Button type="primary" class="edit-template" @click="$refs.contractConfigEdit.open({ id })">编辑模版基本信息</Button>
          <Button type="primary" class="back" @click="back('/operate/onLineInduction')">返回</Button>
        </div>
      </div>
      <Form ref="form" class="page-form detail" :label-width="70">
        <FormItem label="适用机构" class="full">
          <span class="text">{{ tableItem.orgNameList || '未配置适用机构' }}</span>
        </FormItem>
        <FormItem label="签约机构" class="full">
          <span class="text">{{ tableItem.signOrgName || '未配置签约机构' }}</span>
        </FormItem>
      </Form>
    </div>

    <!-- <div class="info-text">
            注意：制作合同时可添加控件（变量/签署区），系统将据此填充合同双方的具体信息。请确保您填写的控件编码和系统保持一致。
            <div class="table-btn" @click="$refs.contractKeysDetail.open()">查看可用编码></div>
        </div> -->

    <div class="desc-box">
      <div class="desc-text">
        <Icon class="icons" type="ios-alert" />
        注意：制作合同时可添加控件（变量/签署区），系统将据此填充合同双方具体信息，请查看
        <a class="code" @click="$refs.contractKeysDetail.open()">系统可用编码 </a>
        确保您填写的控件编码和系统保持一致
      </div>
      <div class="add-refresh">
        <Button type="primary" class="add" @click="$refs.contractConfigUpload.open({}, tableItem)">新增</Button>
        <Button type="primary" class="refresh" @click="reload()">刷新</Button>
      </div>
    </div>

    <!-- <div class="tools-box">
            <Button type="primary" @click="$refs.contractConfigUpload.open({}, tableItem)">新增合同</Button>
            <Button type="primary" @click="reload()">刷新</Button>
        </div> -->
    <div class="table-box" v-loading="listLoading">
      <Table :columns="columns" :data="tableData" :draggable="true" @on-drag-drop="onDragDrop">
        <!-- 图标 -->
        <template slot="icon">
          <Icon type="ios-menu" />
        </template>
        <!-- 模板名称 -->
        <template slot-scope="{ row }" slot="name">
          <span @click="$refs.contractConfigUpload.open(row, tableItem)" class="table-btn">
            {{ row.name }}
          </span>
        </template>
        <!-- 状态 -->
        <template slot-scope="{ row }" slot="templateType">
          <span v-if="row.templateType == 1">代理人</span>
          <span v-else-if="row.templateType == 2">合伙人</span>
        </template>
        <!-- 状态 -->
        <template slot-scope="{ row }" slot="fileStatus">
          {{ fileStatus(row.fileStatus) }}
          <span v-if="row.fileStatus == 3" class="table-btn" @click="preview(row)">预览</span>
        </template>
        <!-- 是否启用 -->
        <template slot-scope="{ row }" slot="isUse">
          <i-switch v-model="row.isUse" @on-change="isUseChange(row)" :disabled="row.fileStatus != 3" />
        </template>
        <!-- 操作 -->
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="openLink(row)" :class="{ disabled: row.fileStatus != 2 && row.fileStatus != 3 }">
            <template v-if="row.fileStatus == 3">重新制作合同</template>
            <template v-else>制作合同</template>
          </span>
          <span class="table-btn red" @click="remove(row)">删除</span>
        </template>
      </Table>
    </div>
    <!-- 上传合同 -->
    <contract-config-upload
      ref="contractConfigUpload"
      @suceess="
        getList();
        $emit('reload');
      "
    ></contract-config-upload>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
    <!-- 合同模板配置 -->
    <contract-keys-detail ref="contractKeysDetail"></contract-keys-detail>
    <!-- 合同模板基本信息编辑 -->
    <contract-config-edit ref="contractConfigEdit" @suceess="getDetail"></contract-config-edit>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import contractConfigUpload from './components/contractConfigUpload';
import contractConfigEdit from './components/contractConfigEdit';
import contractKeysDetail from './components/contractKeysDetail';
import confirmModal from '@/components/commons/confirmModal';
export default {
  mixins: [pageTool, common],
  components: { contractConfigUpload, confirmModal, contractKeysDetail, contractConfigEdit },
  props: [],
  data() {
    return {
      timer: {},
      tableData: [],
      columns: [
        {
          title: ' ',
          width: 80,
          align: 'center',
          slot: 'icon'
        },
        {
          title: '合同名称',
          minWidth: 180,
          align: 'center',
          tooltip: true,
          slot: 'name'
        },
        {
          title: '顺序',
          width: 120,
          align: 'center',
          tooltip: true,
          key: 'orderNum'
        },
        {
          title: '状态',
          width: 150,
          align: 'center',
          slot: 'fileStatus'
        },
        {
          title: '适用对象',
          width: 150,
          align: 'center',
          slot: 'templateType'
        },
        {
          title: '是否启用',
          width: 150,
          align: 'center',
          slot: 'isUse'
        },
        {
          title: '操作',
          width: 220,
          align: 'center',
          slot: 'action'
        }
      ],
      loading: false,
      tableItem: {},
      id: '',
      orgList: []
    };
  },
  activated() {
    this.id = this.$route.query.id;
    if (!this.$units.isOkBao() && !this.$units.isOkTX()) {
      // 删除适用对象
      let idx = this.columns.findIndex(item => item.slot == 'templateType');
      if (idx != -1) {
        this.columns.splice(idx, 1);
      }
    }
    this.getList();
    this.getDetail();
  },
  methods: {
    // 获取详情数据
    getDetail() {
      this.$http({
        url: '/buz/contractTemplate/read/detail',
        type: 'GET',
        data: {
          id: this.id
        }
      }).then(res => {
        res.data.orgNameList = res.data.orgNameList ? res.data.orgNameList.join('，') : '';
        this.tableItem = res.data;
      });
    },
    // 排序
    onDragDrop(index1, index2) {
      const arr = this.tableData.splice(index1, 1);
      this.tableData.splice(index2, 0, arr[0]);
      const numArr = this.tableData.map(item => item.orderNum).sort((a, b) => b - a);
      const params = this.tableData.map((item, i) => {
        this.$set(item, 'orderNum', numArr[i]);
        return {
          id: item.id,
          orderNum: item.orderNum
        };
      });
      this.$http({
        url: '/buz/contract/updateIndexOrder',
        type: 'POST',
        data: params
      }).then(res => {
        this.$notice.success('操作成功');
      });
    },
    async reload() {
      await this.reloadList();
      await this.getList();
      this.$notice.success('刷新成功');
    },
    // 刷新
    reloadList() {
      return this.$http({
        url: '/buz/contract/refreshFileStatus',
        type: 'GET'
      });
    },
    // 获取合同列表
    getList() {
      return this.$http({
        url: '/buz/contract/read/list',
        type: 'POST',
        data: {
          templateId: this.id,
          pageNo: 1,
          pageSize: 99,
          type: this.$route.query.type
        }
      }).then(res => {
        res.data.forEach(item => {
          item.isUse = item.isUse == '1';
        });
        this.tableData = res.data;
      });
    },
    fileStatus(num) {
      const statusMap = {
        1: '转化中',
        2: '可制作',
        3: '已制作',
        4: '转换失败'
      };
      return statusMap[num] || '-';
    },
    preview(item) {
      this.$http({
        url: '/buz/entryUserAuth/previewFile',
        type: 'GET',
        data: {
          id: item.id,
          signOrgId: this.tableItem.signOrgId
        },
        forced: true
      }).then(res => {
        if (res.httpCode != 1) {
          this.$Modal.error({
            title: '提示',
            width: 700,
            closable: true,
            content: `<p style='white-space: pre-wrap;'>${res.msg}<p>`
          });
        } else {
          window.open(res.data.fileDownloadUrl);
        }
      });
    },
    // 获取最新制作链接
    openLink(item) {
      this.$http({
        url: item.fileStatus == 3 ? '/buz/contract/editTemplate' : '/buz/contract/createContractTemplatUrl',
        type: 'GET',
        data: {
          id: item.id
        }
      }).then(res => {
        if (!item.docTemplateId) {
          this.getList();
        }
        window.open(res.data);
      });
    },
    // 修改启用状态
    isUseChange(item) {
      this.$http({
        url: '/buz/contract/edit',
        type: 'POST',
        data: {
          id: item.id,
          isUse: item.isUse ? 1 : 0
        }
      }).then(res => {
        this.$notice.success('操作成功');
      });
    },
    // 删除
    remove(item) {
      if (item.isUse) {
        this.$notice.msg('请将合同置为不启用后再删除');
        return;
      }
      this.$refs.confirmModal
        .open({
          title: '提示',
          content: '请确认是否删除？'
        })
        .then(() => {
          this.$http({
            url: '/buz/contract/del',
            type: 'get',
            data: {
              id: item.id
            }
          }).then(res => {
            this.$notice.success('删除成功');
            this.getList();
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.desc-box {
  display: flex;
  align-items: center;
  margin-bottom: 13px;
  margin-top: 34px;
  .desc-text {
    display: flex;
    align-items: center;
    padding: 2px 5px;
    padding-left: 10px;
    border-radius: 2px;
    background: #fffaf7;
    color: #f59045;
    letter-spacing: 0.8px;
    .icons {
      margin-right: 6px;
    }
    .code {
      color: #236dff;
      letter-spacing: 0px;
      text-decoration: underline;
    }
  }
  .add-refresh {
    margin-left: auto;
    .add {
      width: 80px;
      height: 32px;
      background: #236dff;
      border-radius: 2px;
      color: #ffffff;
    }
    .refresh {
      color: #236dff;
      border: none;
      background: #f4f7ff;
    }
  }
}
.templateName {
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .name {
    font-weight: bold;
    font-size: 14px;
    color: #515c6f;
  }
  .edit-template {
    height: 32px;
    color: #ffffff;
    font-size: 13px;
    border-radius: 2px;
  }
  .back {
    background-color: #f4f7ff;
    color: #236dff;
    border: none;
  }
}
.table-btn.auto {
  padding: 0;
}
/deep/ {
  .ivu-form .ivu-form-item-label {
    text-align: left;
  }
  .ivu-table-row {
    cursor: all-scroll;
  }
}
.page-form.detail {
  padding-top: 10px !important;
  .ivu-form-item {
    margin-bottom: 0px;
  }
  /deep/ .ivu-form-item-content {
    font-size: 13px !important;
    color: #515c6f;
    .text {
      color: #3c464f;
    }
  }
}
.info-text {
  padding-top: 25px;
  line-height: 30px;
}
.back-btn {
  position: absolute;
  right: 20px;
}
</style>
